import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-accidental-medical-expenses-support-doc',
    templateUrl: './accidental-medical-expenses-support-doc.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccidentalMedicalExpensesSupportDocComponent implements OnInit {
  public showAddDoc = false;
  constructor() { }

  ngOnInit() {
  }

}
